var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPinMsg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "9px",
    viewBox: "0 0 9 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPinMsg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "diamond-lists-Read-messages",
    transform: "translate(-14.000000, -277.000000)",
    fill: "#646464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(11.000000, 272.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.947059, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4693706,5.39109283 C10.4587868,5.33978897 10.4231444,5.29706175 10.3745834,5.27772535 C9.94625121,5.10666052 9.49208207,5.01995857 9.0246832,5.01995857 C8.29611373,5.01995857 7.73392767,5.22860463 7.51680432,5.32279165 L5.20097753,3.34876283 C5.2819124,2.63643455 4.89840563,2.14928185 4.88128479,2.12807418 C4.85342452,2.09361171 4.81249015,2.07255998 4.76844291,2.07006496 C4.72455131,2.06912932 4.68112664,2.08425538 4.64999784,2.11559907 L2.27580456,4.49428899 C2.24436448,4.52563268 2.22786621,4.56898366 2.23051216,4.61358215 C2.23300246,4.65786876 2.25432569,4.69919253 2.2890343,4.72679369 C2.62849382,4.99656775 3.0428181,5.05332946 3.33044817,5.05332946 C3.39457349,5.05332946 3.44936017,5.05036663 3.4912284,5.04709191 L5.47133112,7.3790002 C5.33623215,7.72674364 4.92346431,8.98049131 5.42354842,10.2384493 C5.44284828,10.2872582 5.48533908,10.3228122 5.5367016,10.333416 C5.54712974,10.3355992 5.55771353,10.3366907 5.56814168,10.3366907 C5.60907605,10.3366907 5.64876526,10.3204731 5.67818197,10.2910007 L7.94591477,8.01897289 L10.0580036,10.1350619 C10.0883542,10.16547 10.128199,10.180752 10.1680439,10.180752 C10.2078887,10.180752 10.2477336,10.16547 10.2780842,10.1350619 C10.338941,10.0740899 10.338941,9.97553657 10.2780842,9.91456451 L8.16599536,7.79847548 L10.4270355,5.5329971 C10.4640787,5.49588368 10.4799544,5.44255262 10.4693706,5.39109283 Z",
    id: "icPinMsg",
    transform: "translate(6.351413, 6.203357) rotate(-4.000000) translate(-6.351413, -6.203357) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPinMsg);
export default __webpack_public_path__ + "static/media/icPinMsg.a348aadff67111b4f08c4afc3a4d301e.svg";
export { ForwardRef as ReactComponent };